import { CancelOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export default function FileUploadField({
  title,
  inputName,
  acceptedFileTypes,
  onFileUpload,
  onResetUploadedFile,
  uploadedFile,
  required,
  deskripsi = null,
  maxFileSize = null,
}) {
  return (
    <div className="flex flex-col gap-3 p-2 rounded border-2 border-dashed border-slate-300">
      <div>
        <div className="text-lg font-bold">
          {title} {required && <span className="text-red-500">*</span>}
        </div>
        {deskripsi && <small>{deskripsi}</small>}
      </div>
      <div className="flex flex-col">
        <div className="flex flex-row gap-2 items-center border rounded">
          <label className="shrink-0 p-2 text-white bg-sky-600 rounded-l hover:bg-sky-700 hover:cursor-pointer">
            <input
              name={inputName}
              type="file"
              accept={acceptedFileTypes}
              hidden
              onChange={onFileUpload}
              required={required}
            />
            Unggah Berkas
          </label>
          {uploadedFile ? (
            <>
              <div className="truncate">{uploadedFile.name}</div>
              <IconButton
                LinkComponent={"button"}
                onClick={onResetUploadedFile}
                sx={{ padding: 0, marginRight: 1 }}
              >
                <CancelOutlined color="error" />
              </IconButton>
            </>
          ) : (
            <span className="text-slate-500">File belum dipilih.</span>
          )}
        </div>
        <small>
          <b>Format:</b> {acceptedFileTypes}
          {maxFileSize ? (
            <>
              <b> || Maks ukuran file:</b> {maxFileSize}
            </>
          ) : (
            <></>
          )}
        </small>
      </div>
    </div>
  );
}
